
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { setting } from '../../../../../setting';
import { of, Subject } from 'rxjs';

@Injectable()
export class UbicacionesService {

  private airports_airlines: string;
  private searchlocationsAll: string;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  private apiBookingUrl = setting.apiBookingUrl;

  constructor(private http: HttpClient) {
    this.airports_airlines = this.apiBookingUrl + 'utilities/search-airports-and-airlines/';
    this.searchlocationsAll = this.apiBookingUrl + 'search-locations/';
  }

  getCitys(keyword: string, category?: string): Observable<any[]> {
    if (keyword.length >= 3) {
      return this.http
        .get(`${this.searchlocationsAll}${keyword}?category=${category}`)
        .pipe(takeUntil(this._unsubscribeAll))
        .map((res: any) => {
          const mergedArray = [
            {
                cities: res.cities,
                type: 'city',
                pic_mini: '../../../../assets/icons/search-box/ubicacion_gris.svg'
            },
            {
                hotels: res.hotels,
                type: 'hotel',
                pic_mini: '../../../../assets/icons/search-box/hotel_gris.svg'
            },
          ];
          return mergedArray;
        });
    } else {
      return of([]);
    }
  }


  getDestinations(keyword): Observable<any[]> {
    if (keyword.length >= 3) {
      //this.citys
      return this.http.get(this.searchlocationsAll  + keyword )
        .map((res: any) => {
          const json = res;
          return json;
        });
    } else {
      return of([]);
    }
  }

  getAirportsAirlines(keyword: string, type: string): Observable<any[]> {
    if (keyword.length >= 2) {
      return this.http.get(this.airports_airlines + keyword)
      .map((res: any) => {
        switch(type) {
          case 'airport':
            const airports = res.airports;
            return airports;
          case 'airline':
            const airlines = res.airlines;
            return airlines;
        }
      });
    } else {
      return of([]);
    }
  }

  getAirports(keyword): Observable<any[]> {
    if (keyword.length >= 3) {
      return this.http.get(this.searchlocationsAll + keyword)
      .map((res: any) => {
        const json = res.airports;
        json.map((airport: any) => {
          airport.pic_mini = '../../../../assets/icons/search-box/avion_gris.svg';
          return airport;
        });

        return json;
      });
    } else {
      return of([]);
    }
  }

  getAirlines(keyword): Observable<any[]> {
    if (keyword.length >= 3) {
      return this.http.get(this.searchlocationsAll + keyword).pipe(
        debounceTime(300),
        distinctUntilChanged(),
        map((res: any) => {
          const json = res.airlines.slice(0,50);
          return json;
        }),
      );
    } else {
      return of([]);
    }
  }

}
